import React from 'react'
import {getFeConfig,submitEM,visualize} from "../api/api";
import {Form} from '@q4us-sw/q4us-ui'
import {notification} from "antd";
import {isEmpty, validatePhone, validateURL, validateEmail} from "../utils/util";
import {Header} from "./generic/Header";
const Register = (props)=>{

    const [opt, setOpt] = React.useState({countries:{}, loaded:false});
    let cobrand = '', payment_id = null;

    const load = async ()=>{

        const {status = 500, data: {rows =  []} = {}} = await visualize('country');
        let obj = {};
        if(status === 200){
            obj = rows.reduce((acc, {id,...args})=>{
                acc[`${id}`] = {...args};
                return acc;
            },{})
            console.log(obj)
        }
        setOpt({countries: obj, loaded: true});
    }

    React.useEffect(()=>{
        load();
    }, [])


    return <React.Fragment>
        <Header title="Register New E-Merchant"/>
        {opt.loaded && <Form
            schema={`em`}
            config={async (schema) => {
                const res = await getFeConfig(schema) || {}
                const {data: {rows = []} = {}} = res;
                let filteredRows = rows.filter(({generated}) => !generated).sort(({sequence_no: a}, {sequence_no: b}) => {
                    return a - b
                });
                for(let row of filteredRows) {
                    if (row.name === 'dashboard_cobrand_identifier' && row.enums.length > 0) {
                        cobrand = row.enums[0][0]
                    }
                    if (row.name === 'payment_currency_id' && row.enums.length > 0) {
                         row.enums.filter(item => {
                            if (item[1] === 'EUR') {
                                payment_id = parseInt(item[0]);
                            }
                        })
                    }
                }
                return filteredRows
            }}
            maxHeight={"calc(100vh - 106px)"}
            initialValue={{"payment_handling_mode": "indirect", "price_inclusive_vat": true}}
            visibilityValidator={(schema, {name}, form) => {
                if (schema === "em") {
                    if(name === "dashboard_cobrand_identifier" && cobrand !== '') {
                        form.setFieldsValue({dashboard_cobrand_identifier: cobrand})
                    }
                    if(name === "payment_currency_id" && payment_id) {
                        form.setFieldsValue({payment_currency_id: payment_id})
                    }
                    switch (name) {
                        case "po_of_choice": {
                            const state = form.getFieldsValue(['method_of_fulfillment'])['method_of_fulfillment'] || []
                            return state.includes('POSTAL')
                        }
                        case "ioss_registry_import_scheme_id":
                        case "ioss_import_scheme_request_date":
                        case "ioss_import_scheme_registered_country":
                        case "ioss_import_scheme_commencement_date":
                            return form.getFieldsValue(['ioss_registered'])['ioss_registered'];
                        case "ioss_registry_union_scheme_id":
                        case "ioss_union_scheme_request_date":
                        case "ioss_union_scheme_commencement_date":
                        case "ioss_union_scheme_registered_country":
                            return form.getFieldsValue(['ioss_registered'])['ioss_registered']
                        case "ioss_registry_non_union_scheme_id":
                        case "ioss_non_union_scheme_request_date":
                        case "ioss_non_union_scheme_commencement_date":
                        case "ioss_non_union_scheme_registered_country":
                            return form.getFieldsValue(['ioss_registered'])['ioss_registered']
                        case "fee_class_id":
                            return form.getFieldsValue(['fee_class'])['fee_class'] === "manual"
                        case "em_establishment":
                        {
                            const country_id = form.getFieldsValue(['registered_country'])['registered_country']
                            const {is_eu} = opt.countries[`${country_id}`]  || {};
                            return is_eu  === true;
                        }
                        case "custom_checkout_name":
                            return form.getFieldsValue(['checkout'])['checkout'] <= 0
                        case "post_sale_fee_class_id":
                            return form.getFieldsValue(['post_sale_orders_allowed'])['post_sale_orders_allowed'];
                        default:
                            return true;
                    }
                }
                return true;
            }}
            validateField={async  (rule, value, schema, column, form) =>{
                if(column.name === 'fee_class_id' && value == null){
                    const fee_class = form.getFieldsValue(['fee_class']) || {};
                    if(fee_class['fee_class'] === 'manual')
                        return Promise.reject('Need to select a fee class when fee class type is manual')
                }
                if(column.name === 'post_sale_fee_class_id' && value == null){
                    const post_sale_orders = form.getFieldsValue(['post_sale_orders_allowed']) || {};
                    if(post_sale_orders['post_sale_orders_allowed'] === true)
                        return Promise.reject('Need to select a post sale orders fee class when post sale orders are allowed')
                }

                switch (column.name){
                    case "phone":{
                        if(!isEmpty(form.getFieldsValue(['phone'])['phone']))
                            if (!validatePhone(form.getFieldsValue(['phone'])['phone']))
                                return Promise.reject(`Enter a valid [${column.title}]`);
                    }
                        break;
                    case "official_site_url":{
                        if (!isEmpty(form.getFieldsValue(['official_site_url'])['official_site_url']))
                            if (!validateURL(form.getFieldsValue(['official_site_url'])['official_site_url']))
                                return Promise.reject(`Enter a valid [${column.title}]`)
                    }
                        break;
                    case "nominated_email":{
                        if (!isEmpty(form.getFieldsValue(['nominated_email'])['nominated_email']))
                            if (!validateEmail(form.getFieldsValue(['nominated_email'])['nominated_email']))
                                return Promise.reject(`Enter a valid [${column.title}]`);
                    }
                        break;

                    case "web_address":{
                        for(let item of (form.getFieldsValue(['em_site'])['em_site'])){
                            if(!isEmpty(item['web_address']))
                                if(!validateURL(item['web_address']))
                                    return Promise.reject(`Enter a valid [${column.title}]`)
                        }
                    }
                        break;
                }

                return Promise.resolve()
            }}
            submit={async (values) => {
                values._source = 'manual';
                const {status} = await submitEM(values);
                if(status === 200)
                    notification.success({message:`Successfully Registered`})
                return true;
            }}
            onNestedFormRemove={async ({id},schema = [])=>{

            }}
        />}
    </React.Fragment>
}

export default Register
